export default `:host {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: all;
}

.ids-chart-container {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  align-items: center;
}
.ids-chart-container.legend-right .ids-chart-svg-container {
  flex: 1;
  max-width: 75%;
}
.ids-chart-container.legend-right .chart-legend {
  flex: 0 0 25%;
  padding-inline-start: 16px;
}
.ids-chart-container.legend-bottom {
  flex-direction: column;
}
.ids-chart-container.legend-bottom .chart-legend {
  padding-block-start: 16px;
}

.ids-chart-svg-container {
  flex: 1;
  position: relative;
  min-height: 0;
}

.ids-radar-chart {
  width: 100%;
  height: 100%;
  overflow: visible;
}
.ids-radar-chart .chart-radar-axis-wrapper .chart-radar-grid-circle {
  stroke: var(--ids-color-border-default);
  stroke-width: 1px;
  fill: none;
  opacity: 0.3;
}
.ids-radar-chart .chart-radar-axis-wrapper .axis-label {
  font-size: 12px;
  fill: var(--ids-color-text-default);
  font-family: var(--ids-font-family-default);
}
.ids-radar-chart .chart-radar-axis-wrapper .chart-radar-crossline {
  stroke: var(--ids-color-border-default);
  stroke-width: 1px;
  opacity: 0.5;
}
.ids-radar-chart .chart-radar-axis-wrapper .legend {
  font-size: 14px;
  fill: var(--ids-color-text-default);
  font-family: var(--ids-font-family-default);
  font-weight: var(--ids-font-weight-normal);
}
.ids-radar-chart .chart-radar-area {
  cursor: pointer;
  transition: fill-opacity 0.2s ease;
}
.ids-radar-chart .chart-radar-area:hover {
  fill-opacity: 0.4;
}
.ids-radar-chart .chart-radar-area.is-selected {
  fill-opacity: 0.6;
}
.ids-radar-chart .chart-radar-area.is-not-selected {
  fill-opacity: 0.1;
}
.ids-radar-chart .chart-radar-circle {
  cursor: pointer;
  transition: r 0.2s ease;
}
.ids-radar-chart .chart-radar-circle:hover {
  r: 4;
}
.ids-radar-chart .radar-invisible-circle {
  fill: none;
  pointer-events: all;
  cursor: pointer;
}

.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: var(--ids-font-family-default);
  font-size: var(--ids-font-size-default);
}
.chart-legend .chart-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: var(--ids-color-text-default);
  cursor: pointer;
  padding: 4px;
  border-radius: var(--ids-border-radius-default);
  transition: background-color 0.2s ease;
}
.chart-legend .chart-legend-item:hover {
  background-color: var(--ids-color-background-hover);
}
.chart-legend .chart-legend-item:focus {
  outline: 2px solid var(--ids-color-border-focus);
  outline-offset: 2px;
}
.chart-legend .chart-legend-item.selected {
  background-color: var(--ids-color-background-selected);
  font-weight: var(--ids-font-weight-bold);
}
.chart-legend .chart-legend-item.not-selected {
  opacity: 0.5;
}
.chart-legend .chart-legend-item .swatch {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}
.chart-legend .chart-legend-item .swatch.color-1 {
  background-color: var(--ids-chart-color-1, var(--ids-color-blue-60));
}
.chart-legend .chart-legend-item .swatch.color-2 {
  background-color: var(--ids-chart-color-2, var(--ids-color-green-60));
}
.chart-legend .chart-legend-item .swatch.color-3 {
  background-color: var(--ids-chart-color-3, var(--ids-color-orange-60));
}
.chart-legend .chart-legend-item .swatch.color-4 {
  background-color: var(--ids-chart-color-4, var(--ids-color-red-60));
}
.chart-legend .chart-legend-item .swatch.color-5 {
  background-color: var(--ids-chart-color-5, var(--ids-color-purple-60));
}
.chart-legend .chart-legend-item .swatch.color-6 {
  background-color: var(--ids-chart-color-6, var(--ids-color-teal-60));
}
.chart-legend .chart-legend-item .swatch.color-7 {
  background-color: var(--ids-chart-color-7, var(--ids-color-yellow-60));
}
.chart-legend .chart-legend-item .swatch.color-8 {
  background-color: var(--ids-chart-color-8, var(--ids-color-pink-60));
}
.chart-legend .chart-legend-item .swatch.color-9 {
  background-color: var(--ids-chart-color-9, var(--ids-color-indigo-60));
}
.chart-legend .chart-legend-item .swatch.color-10 {
  background-color: var(--ids-chart-color-10, var(--ids-color-cyan-60));
}

text {
  font-family: var(--ids-font-family-default);
  font-size: var(--ids-font-size-default);
  color: var(--ids-color-text-default);
}

:host(.is-small) .ids-radar-chart .legend {
  font-size: 12px;
}
:host(.is-small) .ids-radar-chart .axis-label {
  font-size: 10px;
}

ids-empty-message {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

ids-tooltip {
  pointer-events: none;
  z-index: 1000;
}

@media (prefers-contrast: high) {
  .ids-radar-chart .chart-radar-grid-circle {
    stroke-width: 2px;
    opacity: 0.8;
  }
  .ids-radar-chart .chart-radar-crossline {
    stroke-width: 2px;
    opacity: 0.8;
  }
  .ids-radar-chart .chart-radar-area {
    stroke-width: 2px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .chart-radar-area,
  .chart-radar-circle {
    transition: none;
  }
  .chart-legend-item {
    transition: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
